import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import './i18n';
import '@/App.css';

import Header from './components/Header';
import Footer from './components/Footer';
import BilingualToggle from './components/BilingualToggle';
import WhatsAppButton from './components/WhatsAppButton';
import CookieConsent from './components/CookieConsent';

import HomePage from './pages/HomePage';
import AstrologyServicesPage from './pages/AstrologyServicesPage';
import VastuServicesPage from './pages/VastuServicesPage';
import BookingPage from './pages/BookingPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import HoroscopePage from './pages/HoroscopePage';
import KundliPage from './pages/KundliPage';
import PanchangPage from './pages/PanchangPage';
import DisclaimerPage from './pages/DisclaimerPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AdminPage from './pages/AdminPage';
import AuthCallback from './components/AuthCallback';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/astrology" element={<AstrologyServicesPage />} />
        <Route path="/vastu" element={<VastuServicesPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:postId" element={<BlogPostPage />} />
        <Route path="/horoscope" element={<HoroscopePage />} />
        <Route path="/kundli" element={<KundliPage />} />
        <Route path="/panchang" element={<PanchangPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Footer />
      <BilingualToggle />
      <WhatsAppButton />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
